import React from "react";

const useIdle = (minimumTimeout = 0) => {
  const [idle, setIdle] = React.useState(false);
  const idleCallbackRef = React.useRef<number>();
  const timeoutRef = React.useRef<number>();

  React.useEffect(() => {
    if (idle) return;
    timeoutRef.current = window.setTimeout(
      () => (idleCallbackRef.current = window.requestIdleCallback(() => setIdle(true))),
      minimumTimeout,
    );

    return () => {
      if (typeof idleCallbackRef.current === "number")
        window.cancelIdleCallback(idleCallbackRef.current);
      window.clearTimeout(timeoutRef.current);
    };
  }, [idle, minimumTimeout]);
  return idle;
};

export default useIdle;
